import { ChangeDetectionStrategy, Component } from "@angular/core";

import { PolicyType } from "@bitwarden/common/admin-console/enums";
import {
  BasePolicyEditDefinition,
  BasePolicyEditComponent,
  PolicyCategory,
} from "@bitwarden/web-vault/app/admin-console/organizations/policies";
import { SharedModule } from "@bitwarden/web-vault/app/shared";

export class BlockClaimedDomainAccountCreationPolicy extends BasePolicyEditDefinition {
  name = "blockClaimedDomainAccountCreation";
  description = "blockClaimedDomainAccountCreationDesc";
  type = PolicyType.BlockClaimedDomainAccountCreation;
  category = PolicyCategory.Authentication;
  priority = 60;
  component = BlockClaimedDomainAccountCreationPolicyComponent;
}

@Component({
  selector: "block-claimed-domain-account-creation-policy-edit",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "block-claimed-domain-account-creation.component.html",
  imports: [SharedModule],
})
export class BlockClaimedDomainAccountCreationPolicyComponent extends BasePolicyEditComponent {}
